<template>
  <v-dialog persistent v-model="showNewScopeDialog" width="560" content-class="ec-dialog">
    <v-form v-model="form" ref="newScopeForm" lazy-validation :disabled="loading">

      <div class="ec-dialog__header">
        <h3 class="ec-dialog__title">New Scope</h3>
        <button class="ec-icon-btn" type="button" @click="closeNewScope">
          <v-icon size="18">mdi-close</v-icon>
        </button>
      </div>

      <div class="ec-dialog__body">
        <div class="ec-row">
          <div class="ec-field--half">
            <label class="ec-label">Name *</label>
            <v-text-field
              v-model="scope.name"
              :rules="rules"
              placeholder="Scope name"
              dense outlined hide-details="auto"
            />
          </div>
          <div class="ec-field--half">
            <label class="ec-label">Scope *</label>
            <v-text-field
              v-model="scope.scope"
              :rules="rules"
              placeholder="e.g. containers"
              dense outlined hide-details="auto"
            />
          </div>
        </div>

        <div class="ec-field" style="margin-top:12px">
          <label class="ec-label">Description</label>
          <v-textarea
            v-model="scope.description"
            placeholder="What this scope grants access to"
            outlined dense rows="3" hide-details
          />
        </div>

        <div class="ec-field" style="margin-top:4px">
          <label class="ec-label">Sub Scopes</label>
          <v-combobox
            v-model="subScopes"
            placeholder="Type and press Enter — e.g. containers, models"
            chips clearable multiple outlined dense hide-details
          >
            <template v-slot:selection="{ attrs, item, select, selected }">
              <v-chip
                v-bind="attrs"
                :input-value="selected"
                close
                small
                color="primary"
                outlined
                @click="select"
                @click:close="remove(item)"
              >{{ item }}</v-chip>
            </template>
          </v-combobox>
          <p class="ec-hint">Each sub scope becomes a permission key, e.g. <code>containers</code>, <code>pipelines</code></p>
        </div>
      </div>

      <div class="ec-dialog__footer">
        <button class="ec-btn ec-btn--ghost" type="button" @click="closeNewScope">Cancel</button>
        <button
          class="ec-btn ec-btn--primary"
          type="button"
          :disabled="!form || loading"
          @click="saveScope"
        >
          <v-progress-circular v-if="loading" size="13" width="2" indeterminate style="margin-right:6px" />
          Save Scope
        </button>
      </div>

    </v-form>
  </v-dialog>
</template>

<script>
import { POST_LICENCE_SCOPE_ENDPOINT } from '@/service/backend_endpoints/_endpointPaths'
import { apiService } from '../../service/api.service'
import Swal from 'sweetalert2'

export default {
  props: {
    showNewScopeDialog: { type: Boolean, default: false }
  },
  data () {
    return {
      form: true,
      loading: false,
      subScopes: [],
      scope: { name: '', scope: '', isActive: true, description: '', subScope: {} },
      rules: [(v) => !!v || 'Field is required']
    }
  },
  watch: {
    subScopes (val) {
      this.scope.subScope = val.reduce((acc, curr) => { acc[curr] = []; return acc }, {})
    }
  },
  methods: {
    remove (item) { this.subScopes.splice(this.subScopes.indexOf(item), 1) },
    closeNewScope () { this.$emit('closeNewScopeDialog') },
    async saveScope () {
      if (!this.$refs.newScopeForm.validate()) return
      this.loading = true
      await apiService.post(POST_LICENCE_SCOPE_ENDPOINT, [this.scope])
        .then(async () => {
          await this.$store.dispatch('getLicenceScopes')
          this.$emit('closeNewScopeDialog')
          Swal.fire({ icon: 'success', title: 'Success', text: 'Scope created successfully' })
        })
        .catch(() => {
          Swal.fire({ icon: 'error', title: 'Error', text: 'Failed to create scope' })
        })
        .finally(() => { this.loading = false })
    }
  }
}
</script>
